module.exports = __webpack_public_path__ + "static/media/affiliate.1c0b7c35.png";